import React from 'react';
import Hero from './Hero';
import Features from './Features';
import PricingTable from './PricingTable';
import SignupSection from './SignupSection';
import Footer from './Footer';

/**
 * Dashboard/Landing page component for non-authenticated users
 */
const DashboardPublic = () => {
  return (
    <>
      <Hero />
      <Features />
      <PricingTable />
      <SignupSection />
      <Footer />
    </>
  );
};

export default DashboardPublic;
